import React, {Fragment, useState} from 'react'
import EmployeeIcon from '@mui/icons-material/AssignmentInd';
import {
    Button,
    useNotify,
    useDataProvider,
    Confirm,
    useRefresh,
    SimpleForm,
    ReferenceArrayInput,
    AutocompleteArrayInput,
    useTranslate,
    setListSelectedIds,
} from 'react-admin';
import {fullNameText} from "./FullNameField";
import {useDispatch} from "react-redux";


export const EditHelpersButton = ({selectedIds}) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const dispatch = useDispatch();
    const translate = useTranslate();
    const [isOpen, setOpen] = useState(false);
    const [isExecuting, setExecuting] = useState(false);
    const [employeeIds, setEmployeeIds] = useState();


    const handleAction = e => {
        e.stopPropagation();
        if (!selectedIds || selectedIds.length === 0) {
            notify('app.message.nothing_selected', 'warning');
            return;
        }
        setExecuting(true);

        console.log(employeeIds);

        dataProvider
            .changeHelpersInOrders({orderIds: selectedIds, employeeIds: employeeIds})
            .then(() => {
                notify('app.message.change_helpers_success', 'info');
                refresh();
                handleDialogClose();
                dispatch(setListSelectedIds('orders', []));
            })
            .catch(() => {
                notify('app.message.change_helpers_fail', 'warning')
            })
            .finally(() => {
                setEmployeeIds(undefined);
                setExecuting(false)
            });
    };

    const handleClick = e => {
        setOpen(true);
        e.stopPropagation();
    };

    const handleDialogClose = () => {
        setOpen(false);
    };

    return <Fragment>
        <Button onClick={handleClick} label='app.message.change_helpers'>
            <EmployeeIcon/>
        </Button>
        <Confirm
            isOpen={isOpen}
            loading={isExecuting}
            title='app.message.change_helpers_title'
            content={
                <SimpleForm toolbar={false}>
                    <ReferenceArrayInput
                        source='helpers'
                        reference='employees'
                        sort={{field: 'lastName', order: 'ASC'}}
                        filter={{active: true}}
                        filterToQuery={searchText => ({fullName: searchText})}
                        label='resources.orders.fields.helpers'
                        onChange={setEmployeeIds}
                        allowEmpty allowNull={null}
                    >
                        <AutocompleteArrayInput
                            optionText={fullNameText(translate('resources.orders.fields.noAssignee'))}
                        />
                    </ReferenceArrayInput>
                </SimpleForm>
            }
            onConfirm={handleAction}
            onClose={handleDialogClose}
        />
    </Fragment>
};
